import { defineComponent as r, createBlock as n, openBlock as t, mergeProps as c } from "vue";
import p from "./SvgRender.js";
const m = /* @__PURE__ */ r({
  __name: "Icon.ce",
  props: {
    name: {
      type: String,
      required: !0
    },
    type: {
      type: String,
      default: "icon"
    },
    isSquareSize: {
      type: Boolean,
      default: !1
    }
  },
  setup(o) {
    const e = o;
    return (a, s) => (t(), n(p, c(e, {
      "class-icon": `arbo--icon ${e.type}`
    }), null, 16, ["class-icon"]));
  }
});
export {
  m as _
};
